import { render, staticRenderFns } from "./DiscussionResponses.vue?vue&type=template&id=51767b5d&scoped=true&"
import script from "./DiscussionResponses.vue?vue&type=script&lang=js&"
export * from "./DiscussionResponses.vue?vue&type=script&lang=js&"
import style0 from "./DiscussionResponses.vue?vue&type=style&index=0&id=51767b5d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51767b5d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/kreston-is.sdev.cz/httpdocs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51767b5d')) {
      api.createRecord('51767b5d', component.options)
    } else {
      api.reload('51767b5d', component.options)
    }
    module.hot.accept("./DiscussionResponses.vue?vue&type=template&id=51767b5d&scoped=true&", function () {
      api.rerender('51767b5d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/parts/discussion/DiscussionResponses.vue"
export default component.exports